/* Sokora Custom JS */
(function() {
  function initRatingScroll() {
    document.addEventListener('click', function(e) {
      var ratingLink = e.target.closest('.sk-pdp-rating-link');
      if (ratingLink) {
        e.preventDefault();
        var target = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg, [id*="1748410272b5752b7d"], [data-section-type*="reviews"], .section-apps');
        if (target) {
          var headerOffset = 90;
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        } else {
          var hashTarget = document.getElementById('judgeme_product_reviews');
          if (hashTarget) {
            hashTarget.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }
    });
  }

  function syncJudgeMeRating() {
    var scoreEls = document.querySelectorAll('.sk-pdp-score, .sk-rating-num');
    var countEls = document.querySelectorAll('.sk-pdp-rating-subtext, .sk-rating-count');
    var starPartialStops = document.querySelectorAll('#skStarPartial stop, #skStarPartial2 stop');

    var score = null;
    var avgEl = document.querySelector('.jdgm-rev-widg__summary-average, .jdgm-histogram__summary-average');
    if (avgEl && avgEl.textContent.trim()) {
      var parsed = parseFloat(avgEl.textContent.trim());
      if (!isNaN(parsed) && parsed > 0) score = parsed;
    }

    if (!score) {
      var starEl = document.querySelector('.jdgm-rev-widg__summary-stars, .jdgm-prev-badge__stars, [data-score]');
      if (starEl && starEl.getAttribute('data-score')) {
        var parsedStar = parseFloat(starEl.getAttribute('data-score'));
        if (!isNaN(parsedStar) && parsedStar > 0) score = parsedStar;
      }
    }

    if (!score) {
      var badgeOrWidg = document.querySelector('.jdgm-rev-widg, .jdgm-preview-badge, .jdgm-prev-badge, .jdgm-histogram, .jdgm-widget');
      if (badgeOrWidg) {
        var rawAttr = badgeOrWidg.getAttribute('data-average-rating') || badgeOrWidg.getAttribute('data-score');
        if (rawAttr) {
          var parsedAttr = parseFloat(rawAttr);
          if (!isNaN(parsedAttr) && parsedAttr > 0) score = parsedAttr;
        }
      }
    }

    if (score) {
      scoreEls.forEach(function(el) {
        el.textContent = el.classList.contains('sk-rating-num') ? score.toFixed(1) : score.toFixed(2);
      });
      var fillPct = Math.min(100, Math.max(0, Math.round((score - 4) * 100)));
      starPartialStops.forEach(function(stop) {
        stop.setAttribute('offset', fillPct + '%');
      });
    }

    var numReviews = null;
    var widg = document.querySelector('.jdgm-rev-widg, .jdgm-preview-badge, .jdgm-prev-badge, .jdgm-histogram, .jdgm-widget');
    if (widg && widg.getAttribute('data-number-of-reviews')) {
      numReviews = widg.getAttribute('data-number-of-reviews');
    }
    if (!numReviews) {
      var textEl = document.querySelector('.jdgm-prev-badge__text, .jdgm-rev-widg__summary-text, .jdgm-histogram__summary-text');
      if (textEl) numReviews = textEl.textContent;
    }
    if (numReviews) {
      var cleanCount = ('' + numReviews).replace(/[^0-9]/g, '');
      if (cleanCount && parseInt(cleanCount, 10) > 0) {
        countEls.forEach(function(el) {
          if (el.classList.contains('sk-rating-count')) {
            el.textContent = '(' + cleanCount + ' Reviews)';
          } else {
            el.textContent = cleanCount + ' reviews';
          }
        });
      }
    }
  }

  function init() {
    initRatingScroll();
    syncJudgeMeRating();
    setTimeout(syncJudgeMeRating, 500);
    setTimeout(syncJudgeMeRating, 1200);
    setTimeout(syncJudgeMeRating, 2500);

    // Listen to Judge.me events
    document.addEventListener('jdgm.widgetLoaded', syncJudgeMeRating);
    document.addEventListener('jdgm.done', syncJudgeMeRating);

    // MutationObserver to catch Judge.me rendering dynamically
    if (window.MutationObserver) {
      var observer = new MutationObserver(function() {
        syncJudgeMeRating();
      });
      var obsTarget = document.getElementById('judgeme_product_reviews') || document.body;
      observer.observe(obsTarget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-average-rating', 'data-score', 'data-number-of-reviews']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
